import { CalendarClock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { formatDate, plur } from "@/lib/format";

// Drop-zóna + datum (řízené zvenku). Viditelný jen v režimu „Změnit datum",
// kde jsou vybratelné pouze upravitelné fotky — počet tedy říká pravdu.
export function RedatePanel({ date, onDate, selectedCount, hiddenCount, dragCount, onApply, onDropId }) {
  return (
    <div data-testid="redate-panel"
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => { e.preventDefault(); const id = e.dataTransfer.getData("text/plain"); if (id) onDropId(id, date); }}
      className={`border border-dashed rounded-[14px] p-3.5 ${dragCount > 0 ? "border-brand bg-brand/10" : "border-border bg-secondary/30"}`}>
      <div className="flex items-center gap-2 font-bold text-sm"><CalendarClock size={16} /> Přepsat datum</div>
      {dragCount > 0 ? (
        <p className="text-xs font-bold text-brand mt-1" data-testid="redate-drop-hint">
          Pustit → přesunout {plur(dragCount, "fotku", "fotky", "fotek")} na {formatDate(date || new Date().toISOString().slice(0, 10))}
        </p>
      ) : (
        <p className="text-xs text-muted-foreground mt-1">
          Klepni na fotky v mřížce, nebo je sem přetáhni.
          {hiddenCount > 0 && <> Z toho {hiddenCount} mimo aktuální filtr.</>}
        </p>
      )}
      <div className="flex flex-col gap-2 mt-2">
        <Input type="date" value={date} onChange={(e) => onDate(e.target.value)} className="h-10 min-w-0" data-testid="redate-date" />
        <Button className="h-10 rounded-full" disabled={!date || selectedCount === 0} onClick={onApply} data-testid="redate-apply">
          Přesunout ({selectedCount}){date ? ` na ${formatDate(date)}` : ""}
        </Button>
      </div>
    </div>
  );
}
